import React, { useState } from "react";
import { useContext } from "react";
import "./style.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import { useAuthContext } from "../../AuthContext";
import { SidebarContext } from "../Context/SidebarContext";
import useAuth from "../../Auth";

const MobileHeader = () => {
  const { logOut, isAuthenticated } = useAuthContext();
  const { Login } = useAuth();
  const { dispatch, state } = useContext(SidebarContext);
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (localStorage.getItem("IS_MOBILE_APP") == "true") {
      // localStorage.removeItem("IS_MOBILE_APP");
      window?.ReactNativeWebView?.postMessage("BACK");
    } else {
      navigate(-1);
    }
  };
  return (
    <>
      <header>
        <nav className='navbar navbar-expand-md mobile-back-connect'>
          <div className='container-1280'>
            <Link
              className='navbar-brand navbar-back'
              onClick={() => handleNavigate()}>
              Back
            </Link>

            <Button
              value={isAuthenticated ? `Disconnect` : `Connect Wallet`}
              onClick={() => {
                isAuthenticated ? logOut() : Login();
              }}
            />
          </div>
          {state.showSearch ? (
            <div className='search-icon'>
              <img
                src={require("./../../Assets/img/search.png")}
                alt='search'
                onClick={() => dispatch({ type: "TOGGLE", data: true })}
              />
            </div>
          ) : (
            ""
          )}
        </nav>
      </header>
    </>
  );
};

export default MobileHeader;
